import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import styled from 'styled-components'
import { indexBy, prop } from 'ramda'
import {
  Button as OriginalButton,
  Colors,
  ContextMenu,
  Display,
  Table,
  TableCell as OriginalTableCell,
  TableHeader,
  TableLoading,
  TextIcon,
  Title1,
  Pagination,
} from 'advenio-components'
import { userHasRole, stringContainsAnyOf } from '../../../utils/Utils'
import ProfileHeader from '../../ProfileHeader'
import AddChargeModal from './AddChargeModal'
import AddDepositModal from './AddDepositModal'
import AddAdjustmentModal from './AddAdjustmentModal'
import AddDiscountModal from './AddDiscountModal'
import ConfirmDeleteChargeModal from './ConfirmDeleteChargeModal'
import ConfirmChangeChargeModal from './ConfirmChangeChargeModal'
import BalanceActions, { Selectors as BalanceSelectors } from '../../../Data/Redux/BalanceRedux'
import ClassroomActions, { Selectors as ClassroomSelectors } from '../../../Data/Redux/ClassroomRedux'
import CenterActions from '../../../Data/Redux/CenterRedux'
import CardActions from '../../../Data/Redux/CardsRedux'
import UnitKeysActions from '../../../Data/Redux/UnitKeysRedux'
import CountriesActions from '../../../Data/Redux/CountriesRedux'
import { formatPrice } from '../../../utils/Utils'
import LinkChargeModal from './LinkChargeModal'
import ConfirmModal from '../../ConfirmModal'
import { notificationFail } from '../../../Data/Redux/NotificationActions'


const Container = styled.div`
  padding: 8px;
`
const Button = styled(props => <OriginalButton small {...props} />)`
  font-size: 14px;
`
const TableContainer = styled.div`
  margin: 8px;
`
const TableCell = styled(OriginalTableCell)`
  ${({ isActionColumn, isInactive }) => {
    if (!isInactive) return {}

    return {
      color: isActionColumn ? Colors.red500 : Colors.red300,
      backgroundColor: Colors.red100,
      textDecoration: !isActionColumn && 'line-through',
    }
  }}
`
const DeletedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const BalanceContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  width: 100%;
`
const DomiciliationBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: #e8f5e9;
  color: #2e7d32;
  font-size: 13px;
  font-weight: 600;
`
const Info = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50%;
`
const Description = styled.div`
  display: flex;
  flex-direction: column;
`
const DiscountContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: ${Colors.blue500};
`

const LinkedChargeContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #008076;
`

const Total = styled.div`
  display: flex;
  flex-direction: column;
`
const StrikedText = styled.p`
  margin: 0;
  text-decoration: line-through;
`
const Span = styled.span`
  color: ${props => props.blue ? Colors.blue500 : ''};
  margin-right: ${props => props.blue ? '' : '5px'};
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Icon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 6px;
  cursor: pointer;
`

class Balance extends Component {
  state = {
    addAdjustmentOpen: false,
    isChargeModalOpen: false,
    balance: {},
    chargeId: null,
    chargeChangeId: null,
    discount: null,
    isDiscountBeingEdited: false,
    isDepositModalOpen: false,
    isConfirmDeleteChargeModalOpen: false,
    isMexican: false,
    is_retention: false,
    isDiscountModalOpen: false,
    isLinkChargeModalOpen: false,
    isUnlinkChargeModalOpen: false,
    total: 0,
    totals_before_retention: null,
    unitKeys: [{ label: '', id: 0, value: 0 }],
    typeToDelete: 'cargo',
    pageSelected: 1,
    isChangeCharge: false,
  }

  componentDidMount = () => {
    const { activeStudentId, getBalance,getMore, getCards, getCenter, getCountries,
      getUnitKeys, user, student, getReceipts } = this.props
      const{pageSelected}=this.state
    getMore(activeStudentId,pageSelected)
    getCenter(user.center_id)
    getCards(activeStudentId)
    getUnitKeys()
    getCountries()
     getReceipts(student.id)
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.unitKeys.length > 0) {
      const unitKeys = nextProps.unitKeys.map(key => ({
        label: `${key.name} (${key.sat_key})`,
        value: key.id,
        id: key.id,
      }))
      this.setState({ unitKeys })
    }
    if (nextProps.countries) {
      const country = nextProps.countries.find(c => c.id === nextProps.user.country_id)
      if (country && country.name === 'Mexico') {
        this.setState({ isMexican: true })
      }
    }
    if (nextProps.balance) {
      this.setState({ balance: nextProps.balance })
    }

    if (this.props.isSending && !nextProps.isSending) {
      this.closeAllModals()
    }

    if (this.props.isSendingLinkedReceipt && !nextProps.isSendingLinkedReceipt) {
      this.closeAllModals()
    }

    if (this.props.activeStudentId !== nextProps.activeStudentId) {
      nextProps.getBalance(nextProps.activeStudentId)
       nextProps.getReceipts(nextProps.activeStudentId)
    }
  }

  getDiscount = (discount) => {
    if (!discount) {
      return ''
    }

    return (
      <DiscountContainer>
        <span>{`Descuento: ${formatPrice(discount.discount_amount, this.props.center.currency)}`}</span>
        <span>{discount.description}</span>
      </DiscountContainer>
    )
  }

  getReceiptInfo = (receipt) => {
    if (!receipt) return ''
    const { created_at, id: receiptNumber, total_formatted } = receipt

    return (
      <LinkedChargeContainer>
        <span>{`Vinculado al recibo #${receiptNumber} (${moment(created_at).format('DD MMM YYYY')} - ${total_formatted})`}</span>
      </LinkedChargeContainer>
    )
  }

  generatePrice = (value, discount = null) => {
    const {
      center: { currency },
    } = this.props

    if (!value && value !== 0) {
      return ''
    }

    const formattedPrice = formatPrice(value, currency)

    if (discount) {
      return (
        <Total>
          <StrikedText>{formattedPrice}</StrikedText>
          <span>{formatPrice(discount.new_total, currency)}</span>
        </Total>
      )
    }

    return <Display>{formattedPrice}</Display>
  }

  closeAdjustment = () => this.setState({ addAdjustmentOpen: false })
  closeCharge = () => this.setState({ isChargeModalOpen: false })
  closeDepositModal = () => this.setState({ isDepositModalOpen: false })

  openDepositModal = () => this.setState({ isDepositModalOpen: !this.state.isDepositModalOpen })
  toggleAdjustment = () => this.setState({ addAdjustmentOpen: !this.state.addAdjustmentOpen })
  toggleCharge = () => this.setState({ isChargeModalOpen: !this.state.isChargeModalOpen })

  confirmDeleteCharge = (id, type) => {
    this.setState({
      typeToDelete: type,
      chargeId: id,
      isConfirmDeleteChargeModalOpen: true,
    })
  }

  closeDeleteChargeModal = () => this.setState({ isConfirmDeleteChargeModalOpen: false })

  toggleConfirmChangeCharge = (id = '',typeToCharge = 'directo') => {
    this.setState({
      chargeChangeId: id,
      isChangeCharge: !this.state.isChangeCharge,
      typeToCharge
    })
  }

  /**
   * Add a discount for the specified charge
   *
   * @param {{chargeId: number, total: number, is_retention: boolean, totals_before_retention: number }} charge  The charge to be discounted
   *
   * @return void
   */
  addDiscount = ({ chargeId, total, is_retention, totals_before_retention }) => {
    this.setState({
      chargeId,
      total,
      is_retention,
      totals_before_retention,
      isDiscountModalOpen: true,
    })
  }

  /**
   * Edit the specified discount
   *
   * @param {{total: number, discount: object, is_retention: boolean, totals_before_retention: number }} charge  The charge object with the discount to be amended
   *
   * @return void
   */
  adjustDiscount = ({ total, discount, is_retention, totals_before_retention }) => {
    this.setState({
      chargeId: discount.id,
      total,
      discount,
      is_retention,
      totals_before_retention,
      isDiscountModalOpen: true,
      isDiscountBeingEdited: true,
    })
  }

  /**
   * Link a charge to a previous receipt
   *
   * @param {chargeId: number}
   *
   * @return void
   */
  linkCharge = (chargeId) => {
    this.setState({
      isLinkChargeModalOpen: true,
      chargeId,
    })
  }

  /**
   * Unink a charge to a previous receipt
   *
   * @param {chargeId: number}
   *
   * @return void
   */
  unlinkCharge = (chargeId, studentReceiptId) => {
    this.setState({
      isUnlinkChargeModalOpen: true,
      chargeId,
      studentReceiptId,
    })
  }

  closeModal = () => {
    this.setState({
      discount: {},
      isDiscountBeingEdited: false,
      isDiscountModalOpen: false,
    })
  }

  closeAllModals = () => {
    this.setState({
      addAdjustmentOpen: false,
      isChargeModalOpen: false,
      isDiscountBeingEdited: false,
      isConfirmDeleteChargeModalOpen: false,
      isDepositModalOpen: false,
      isDiscountModalOpen: false,
      isLinkChargeModalOpen: false,
      isUnlinkChargeModalOpen: false,
      isChangeCharge:false,
    })
  }

  handleDelete = (id) => {
    if (this.state.typeToDelete === 'cargo') {
      this.props.deleteCharge(id)
    } else {
      this.props.deletePayment(id)
    }
  }

  hanledReceipt = () => {
    const {studentProfile:{id}, createReceipt} = this.props
    createReceipt(Number(id))
  }

  handleChange = (id) => {
    this.props.changeCharge(id)
  }

  getButtonAdjuste = (user,toggleAdjustment,loading) =>{
    if(userHasRole(user, ['Back Office Admin'])){
        return (
            <Button
              primary key="adjustment"
              onClick={toggleAdjustment}
              disabled={loading}
              >
              <TextIcon iconType='plus' label='Ajuste' />
              </Button>
        )
    }
  }
  handleRefreshBalance = () => {
    const {activeStudentId} =this.props;
    this.props.getBalance(activeStudentId);
  }

  getButtonReceipt = (student, user, loading) =>{
    //TODO: no create recepit student (no active)
    if(userHasRole(user, ['Director','Receptionist','Back Office Admin']) && !(!! stringContainsAnyOf(String(student.status_id) , ['3'])) ){
      return (
          <Button
            primary key="receipt"
            onClick={this.hanledReceipt}
            disabled={loading}
            >
            <TextIcon iconType='plus' label='Recibo' />
            </Button>
      )
    }
  }

  onClickPage = (pageSelected) => {
    this.setState({ pageSelected }, () => {
      // const queries = { ...this.state.queryParams, page: pageSelected }
      const {activeStudentId} =this.props;
      // this.props.getReceipts(queries)
      this.props.getMore(activeStudentId,pageSelected);
      //  this.props.goTo(`?${queryString.stringify(queries)}`)

    })
  }

  render() {
    const {
      activeStudentId,
      adjustDiscount,
      cards,
      center,
      center: { currency },
      consumables,
      createDiscount,
      createPayment,
      isSending,
      isSendingDiscount,
      isSendingUnLinkedReceipt,
      loading,
      paymentTypes,
      student,
      receipts,
      isSendingLinkedReceipt,
      unlinkChargeToReceipt,
      user,
      toastError,
      balance,
      meta,
      paymentTypesMsi,
    } = this.props
    const {
      addAdjustmentOpen,
      isChargeModalOpen,
      chargeId,
      chargeChangeId,
      discount,
      isDiscountBeingEdited,
      isConfirmDeleteChargeModalOpen,
      isDepositModalOpen,
      isMexican,
      is_retention,
      isDiscountModalOpen,
      isLinkChargeModalOpen,
      isUnlinkChargeModalOpen,
      total,
      totals_before_retention,
      studentReceiptId,
      typeToDelete,
      typeToCharge,
      pageSelected,
      isChangeCharge,
    } = this.state

    const receiptsById = indexBy(prop('id'), receipts)

    return (
      <Container>
        <ProfileHeader
          header="Estado de Cuenta"
          noSave
          buttons={[
            <Button
              transparent
              key="update"
              onClick={this.handleRefreshBalance}
              disabled={loading}
            >
              <Icon src="/assets/refresh.svg" alt="update" style={{ filter: 'invert(41%) sepia(7%) saturate(1012%) hue-rotate(169deg) brightness(92%) contrast(87%)' }} />
              Actualizar
            </Button>,
            <Button
              primary
              key="deposit"
              onClick={this.openDepositModal}
              disabled={loading}
            >
            <TextIcon iconType='plus' label='Deposito' />
            </Button>,
             this.getButtonAdjuste(user, this.toggleAdjustment,loading),
             (this.getButtonReceipt(student,user,loading)),
            <Button
              success
              key="charge"
              onClick={this.toggleCharge}
              disabled={loading}
            >
              <TextIcon iconType='plus' label='Cargo' />
            </Button>,
          ]}
        />
        <Title1 style={{ padding: '0 16px' }}>Número de Cuenta a depositar: <span style={{ color: Colors.advenioRed }}>#{balance.id}</span></Title1>
        {(balance && balance.formatted_balance) &&
        <BalanceContainer>
          <Info>
            <Span>Saldo actual: </Span>
            <Span blue>{`${balance.formatted_balance}`}</Span>
          </Info>
          <Info>
            {balance.domiciliation &&
              <DomiciliationBadge>
                <img src="/assets/card-tick.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
                Domiciliado
              </DomiciliationBadge>
            }
          </Info>
        </BalanceContainer>
        }
        <TableContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {loading ? (
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Fecha',
                  element: 'Text',
                  width: '100px',
                  center: true,
                },
                {
                  id: 2,
                  header: 'Concepto',
                  element: 'Text',
                },
                {
                  id: 3,
                  header: 'Cargo + IVA',
                  element: 'Text',
                  width: '220px',
                },
                {
                  id: 4,
                  header: 'Pago',
                  element: 'Text',
                  width: '220px',
                },
                {
                  id: 5,
                  header: '',
                  element: 'Text',
                  width: '90px',
                },
              ]}
              rows={5}
            />
          ) : (
            <Table
              roundedCorners
              data={balance && balance.transactions}
              columns={[
                {
                  id: 'date',
                  Header: () => <TableHeader title="Fecha" blue center />,
                  maxWidth: 100,
                  Cell: ({ original: { deleted_at, id, registered_at }, index }) => (
                    <TableCell index={index} isInactive={!!deleted_at} center noEllipsis>
                      {moment(registered_at).format('DD MMM YY')}
                      <p style={{ color: '#d3d3d3', fontSize: '13px' }}>{ `(ST ID: ${id})`}</p>
                    </TableCell>
                  ),
                },
                {
                  id: 'description',
                  Header: () => <TableHeader title="Concepto" blue />,
                  Cell: ({
                    original: {
                      deleted_at,
                      description,
                      discount,
                      quantity,
                      student_receipt_id,
                      is_retention,
                    },
                    index,
                  }) => (
                    <TableCell index={index} isInactive={!!deleted_at} noEllipsis>
                      <Description>
                        <div>
                          {description} {quantity > 1 && `(${quantity})`} {is_retention && <strong style={{ color: Colors.blue500 }}>(R)</strong>}
                        </div>
                        {this.getDiscount(discount)}
                        {this.getReceiptInfo(receiptsById[student_receipt_id])}
                      </Description>
                    </TableCell>
                  ),
                },
                {
                  id: 'charge',
                  Header: () => <TableHeader title="Cargo +IVA" blue noEllipsis />,
                  maxWidth: 250,
                  Cell: ({ original: { deleted_at, type, total, discount }, index }) => (
                    <TableCell index={index} isInactive={!!deleted_at} noEllipsis>
                      {type !== 'Payment' && this.generatePrice(total, discount)}
                    </TableCell>
                  ),
                },
                {
                  id: 'payment',
                  Header: () => <TableHeader title="Pago" blue noEllipsis />,
                  maxWidth: 250,
                  Cell: ({ original: { deleted_at, total, type }, index }) => (
                    <TableCell index={index} isInactive={!!deleted_at} noEllipsis>
                      {type === 'Payment' && this.generatePrice(total)}
                    </TableCell>
                  ),
                },
                {
                  Header: () => <TableHeader blue />,
                  id: 'context-menu',
                  width: 110,
                  sortable: false,
                  Cell: ({
                    original,
                    original: {
                      id: chargeId,
                      deleted_at,
                      discount,
                      student_receipt_id,
                      type,
                      is_retention,
                    },
                    index,
                  }) => {
                    const charge = { ...original }
                    charge.chargeId = chargeId

                    if (deleted_at) {
                      return (
                        <TableCell index={index} isInactive={!!deleted_at} isActionColumn>
                          <DeletedText
                            label="Borrado"
                            iconType="checkmark"
                            iconViewBox="0 1 18 18"
                            iconColor={Colors.red500}
                          />
                        </TableCell>
                      )
                    }

                    if (charge.is_locked) {
                      return <TableCell index={index} />
                    }

                    if (type === 'Payment') {
                      return (
                        <TableCell index={index}>
                          <ContextMenu
                            value={type}
                            elements={
                              [{
                                id: 0,
                                icon: 'remove',
                                label: 'Borrar Pago',
                                onClick: () => this.confirmDeleteCharge(chargeId, 'pago'),
                              }]
                            }
                          />
                        </TableCell>
                      )
                    }

                    let elements = []

                    if (!discount) {
                      elements = [
                        {
                          id: 1,
                          icon: 'plus',
                          label: 'Agregar Descuento',
                          onClick: () => this.addDiscount(charge),
                        },
                      ]
                    } else {
                      elements = [
                        {
                          id: 1,
                          icon: 'edit',
                          label: 'Ajustar Descuento',
                          onClick: () => this.adjustDiscount(charge),
                        },
                      ]
                    }
                    if (student_receipt_id) {
                          elements.push({
                            id: 2,
                            icon: 'edit',
                            label: 'Desvincular recibo',
                            onClick: () => this.unlinkCharge(chargeId, student_receipt_id),
                          })
                    } else {
                          elements.push({
                            id: 2,
                            icon: 'edit',
                            label: 'Vincular con recibo',
                            onClick: () => receipts.length > 0 ? this.linkCharge(chargeId) : toastError('No hay recibos sin validar.'),
                          })
                    }
                    if(userHasRole(user,['Back Office Admin','Director'])){
                        elements.push({
                          id: 4,
                          icon: 'edit',
                          label: `Cambiar a ${is_retention ? "Directo" : "retención"}`,
                          onClick: () => this.toggleConfirmChangeCharge(chargeId, is_retention ? 'directo':'retención'),
                        })
                    }
                    if(userHasRole(user,['Back Office Admin','Director','Coordinator'])){
                        elements.push({
                          id: 3,
                          icon: 'remove',
                          label: 'Borrar Cargo',
                          onClick: () => this.confirmDeleteCharge(chargeId, 'cargo'),
                        })
                    }
                    return (
                      <TableCell index={index} isInactive={!!deleted_at} center>
                        <ContextMenu value={type} elements={elements} />
                      </TableCell>
                    )
                  },
                },
              ]}
            />
          )}
        </TableContainer>
        <AddChargeModal
          isOpen={isChargeModalOpen}
          onClose={this.closeCharge}
        />
        <AddDepositModal
          onClose={this.closeDepositModal}
          isOpen={isDepositModalOpen}
          studentId={Number(activeStudentId)}
          isSending={isSending}
          submitDeposit={createPayment}
          currency={currency}
          parents={student.parents}
          cards={cards}
          paymentTypes={paymentTypes}
          hasPaymentMSI={balance.has_payment_msi}
          paymentTypesMsi={paymentTypesMsi}
          totalBalance={balance.balance}
        />
        <AddAdjustmentModal
          onClose={this.closeAdjustment}
          open={addAdjustmentOpen}
          sendAdjustment={createPayment}
          studentId={activeStudentId}
          sending={isSending}
          currency={currency}
        />
        <AddDiscountModal
          onClose={this.closeModal}
          open={isDiscountModalOpen}
          chargeId={chargeId}
          currency={currency}
          discount={discount}
          editMode={isDiscountBeingEdited}
          total={total}
          sendDiscount={isDiscountBeingEdited ? adjustDiscount : createDiscount}
          sending={isSendingDiscount}
          is_retention={is_retention}
          totals_before_retention={totals_before_retention}
        />
        <LinkChargeModal
          onClose={this.closeAllModals}
          open={isLinkChargeModalOpen}
          chargeId={chargeId}
          receipts={receipts}
          sending={isSendingLinkedReceipt}
        />
        <ConfirmModal
          onClose={this.closeAllModals}
          isOpen={isUnlinkChargeModalOpen}
          title="Desvincular recibo"
          message="¿Seguro que quieres desvincular el recibo de este cargo?"
          callback={() => unlinkChargeToReceipt(chargeId, studentReceiptId)}
          loading={isSendingUnLinkedReceipt}
        />
        <ConfirmDeleteChargeModal
          chargeId={chargeId}
          handleSubmit={this.handleDelete}
          isOpen={isConfirmDeleteChargeModalOpen}
          loading={isSending}
          onClose={this.closeDeleteChargeModal}
          typeToDelete={typeToDelete}
        />
        <ConfirmChangeChargeModal
          chargeId={chargeChangeId}
          handleSubmit={this.handleChange}
          isOpen={isChangeCharge}
          loading={isSending}
          onClose={this.toggleConfirmChangeCharge}
          typeToCharge={typeToCharge}
        />
      </Container>
    )
  }
}

Balance.propTypes = {
  /** The ID of the active student */
  activeStudentId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  /** The active student's account transactions */
  balance: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** The credit cards registered for the active student */
  cards: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** The active Center */
  center: PropTypes.object.isRequired,
  /** An array of all consumables available at the current center */
  consumables: PropTypes.array.isRequired,
  /** The available countries */
  countries: PropTypes.array.isRequired,
  /** Flag marking when the balance is in the process of being stored */
  isSending: PropTypes.bool.isRequired,
  /** Indicates that a discount is in the process of being applied */
  isSendingDiscount: PropTypes.bool.isRequired,
  /** Indicates that a charge is in the process of being linked to a receipt */
  isSendingLinkedReceipt: PropTypes.bool.isRequired,
  /** Indicates that a charge is in the process of being linked to a receipt */
  isSendingUnLinkedReceipt: PropTypes.bool.isRequired,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** The available payment types for the active student's paying parent */
  paymentTypes: PropTypes.array.isRequired,
  /** The active student */
  student: PropTypes.object.isRequired,
  /** The available unit keys for the current center */
  unitKeys: PropTypes.array.isRequired,
  /** The authenticated User */
  user: PropTypes.object.isRequired,

  /** Attempt to adjust the specified discount */
  adjustDiscount: PropTypes.func.isRequired,
  /** Attempt to store a new discount for the specified charge */
  createDiscount: PropTypes.func.isRequired,
  /** Attempt to store a new payment for the active student */
  createPayment: PropTypes.func.isRequired,
  /** Submit a request to the API to delete the specified charge */
  deleteCharge: PropTypes.func.isRequired,
  /** Submit a request to the API to delete the specified payment */
  deletePayment: PropTypes.func.isRequired,
  /** Fetch the current student's account balance */
  getBalance: PropTypes.func.isRequired,
  /** Fetch the available credit cards for the specified student */
  getCards: PropTypes.func.isRequired,
  /** Fetch the details of the current Center */
  getCenter: PropTypes.func.isRequired,
  /** Fetch the listing of available countries from the API */
  getCountries: PropTypes.func.isRequired,
  /** Fetch the listing of available unit keys from the API */
  getUnitKeys: PropTypes.func.isRequired,
  /** Fetch the listing of unvalidated receipts */
  getReceipts: PropTypes.func.isRequired,
  /** Show error notification */
  toastError: PropTypes.func.isRequired,
  /** Meta data for the paginated results */
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** Fetch the next page of the current student's account balance details */
  getMore: PropTypes.func.isRequired,
}

Balance.defaultProps = {
  balance:{} ,
}

const mapStateToProps = ({ balance, centers, ...state }) => ({
  balance: balance.get.results.data,
  meta: balance.get.results.meta,
  loading: balance.get.fetching || centers.getOne.fetching||balance.receipts.fetching,
  consumables: state.consumables.get.results,
  activeStudentId: state.classrooms.activeStudentId,
  center: centers.getOne.result,
  user:  ClassroomSelectors.activeUser(state , state.classrooms.center_id),
  isSending: balance.create.fetching,
  isSendingDiscount: balance.discount.fetching,
  isSendingLinkedReceipt: balance.receipts.fetching,
  isSendingUnLinkedReceipt: balance.receipts.fetching,
  cards: state.cards.get.results,
  paymentTypes: state.parent_payment_types.get.results,
  unitKeys: state.unitKeys.get.results,
  countries: state.countries.get.results,
  receipts: BalanceSelectors.getStudentReceipts({ balance }),
  studentProfile: ClassroomSelectors.activeStudent(state),
  paymentTypesMsi: state.payment_types_msi.get.results
})

const mapDispatchToProps = dispatch => ({
  getReceipts: studentId => dispatch(BalanceActions.getUnvalidatedReceiptsRequest(studentId)),
  getBalance: studentId => dispatch(BalanceActions.getRequest({studentId}, true)),
  getCenter: centerId => dispatch(CenterActions.getOneRequest(centerId)),
  deleteCharge: chargeId => dispatch(BalanceActions.deleteChargeRequest(chargeId)),
  deletePayment: paymentId => dispatch(BalanceActions.deletePaymentRequest(paymentId)),
  createDiscount: (chargeId, data) =>
    dispatch(BalanceActions.createDiscountRequest(chargeId, data)),
  adjustDiscount: (chargeId, data) =>
    dispatch(BalanceActions.adjustDiscountRequest(chargeId, data)),
  createPayment: (studentId, payment) =>
    dispatch(BalanceActions.createPaymentRequest(studentId, payment)),
  changeCharge: chargeId =>
    dispatch(BalanceActions.changeChargeRequest(chargeId)),
  getCards: student_id => dispatch(CardActions.getRequest({ student_id }, true)),
  getUnitKeys: () => dispatch(UnitKeysActions.getRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  unlinkChargeToReceipt: (chargeId, receiptId) => dispatch(
    BalanceActions.unlinkChargeToReceiptRequest(chargeId, receiptId)),
  toastError: msg => dispatch(notificationFail(msg)),
  getMore: (studentId, page) => dispatch(BalanceActions.getMoreRequest({ studentId, page })),
  createReceipt: studentId =>dispatch(BalanceActions.createReceiptRequest(studentId)),

})

export default connect(mapStateToProps, mapDispatchToProps)(Balance)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/index.jsx